<template>
    <li
        :class="[
            'Section',
            open && 'Section--open',
        ]"
    >
        <a
            :class="[
                'Section__container',
                open && 'Section__container--open',
                isActive && 'Section__container--active'
            ]"
            :href="section.path"
            @click.prevent="nav"
        >
            <StreamlineIcon
                :class="[ 'Section__menu', open && 'Section__menu--open' ]"
                :icon="icon"
                :stroke="white"
                :size="20"
            />
            <template v-if="open">
                {{ section.label }}
            </template>
        </a>
    </li>
</template>

<script>
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import navIconHelper from '../navIconHelper';
import {white} from 'style/_colors.scss';

export default {
    name: "Section",
    components: {
        StreamlineIcon,
    },
    props: {
        section: {
            type: Object,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: true,
        },
        open: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            white,
        };
    },
    computed: {
        icon() {
            return navIconHelper(this.section.icon);
        }
    },
    methods: {
        nav(){
            this.$emit('navigate', this.section.to);
        }
    }
};
</script>

<style lang="scss">
.Section {
    height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;

    &__container{
        height: fit-content;
        display: flex;
        align-items: center;
        color: $white;
        border-radius: 4px;
        opacity: .7;
        &:hover {
            background: $highlight-blue;
            opacity: 1;
        }
        &--open {
            padding: 0.5rem;
            border-radius: 0;
            width: 100%;
            height: 100%;
        }
        &--active {
            background: $primary-500;
        }
    }
    &__menu {
        border-radius: 4px;
        padding: 0.5rem;
    }
}
</style>